import { Component, OnInit,ElementRef } from '@angular/core';
import { TicketsService,BatchService,FacilityService,MessageService } from 'src/app/services';
import { ActivatedRoute,Router } from '@angular/router';
import { AccessUserInfo, TicketDetails, UserFacility, UserLocationFacility } from 'src/app/models';
import { DatePipe } from '@angular/common';
import { ConfService } from 'src/conf.service';

@Component({
  selector: 'bart-ticket-search',
  templateUrl: './ticket-search.component.html',
  styleUrls: ['./ticket-search.component.scss']
})
export class TicketSearchComponent implements OnInit {
  datePiepe = new DatePipe('en-US')
  first: number = 0;
  public totalRecords = 0;
  userDetail :any  =null;
  errors :any[];
  public userFacilityIdList:any;
  public partUsedColumns: any[];
  public equpmentUsedColumns: any[];
  public partTotalAmount:number=0;
  ShowLodingGrid = false;
  dialogHeader:string;
  ShowAlertpopup:boolean;
  ShowPrintPopup:boolean;
  SearchTicketColumns:any;
  SearchTicketResult:any[];
  public selectedTicket: any[];
  tiketSrch: ticketSearch | undefined;
  public totalRecordsTicektSearch:number=0;
  public showSignatureLine:boolean=false;
  dashTicketsParam={
    ticketStatusId:0, 
    facilityMasterIdList :'' ,
    ticketSearchStartDate:'',
    ticketSearchEndDate:'', 
    userId :0,  
    nextTicketId :0,  
    returnTotalCount :0,  
    returnAllRecords :1,  
    bartRoleCode :'',
    maxRecords :0,  
    orderBy :'',
    SearchTerm :''  

  }
  
  
  constructor(private _messageService:MessageService,private _batchService: BatchService,private _TicketsService:TicketsService,private _Router: Router,private facilityService:FacilityService)
   { 
    var startDate = new Date();
    startDate.setDate(startDate.getDate()-90);
    this.tiketSrch={ticketStatusId:2,ticketSearchStartDate:startDate,ticketSearchEndDate:new Date(),searchTerm:''};
    this.userDetail = AccessUserInfo.getUserInfo();
   }

  ngOnInit() {
    this.applyPrintCSSForProductionBuild();
    this.checkCreateTicketPermission();
    this.partUsedColumns = 
    [
      {field: 'PartNumber', header: 'Part#'},
      {field: 'manufacturerName', header: 'Vendor'},
      {field: 'partDescription', header: 'Part Name'},
      {field: 'DateOfInstall', header: 'Date Installed'},
      {field: 'UnitCost', header: 'Price'},
      {field: 'Quantity', header: 'Quantity'},
      {field: 'Total', header: 'Total'}
    ]
    
    this.equpmentUsedColumns = 
    [
      {field: 'equipmentId', header: 'Equipment ID'},
      {field: 'EquipmentSubTypeCode', header: 'Subtype'},
      {field: 'manufacturerName', header: 'Manufacturer'},
      {field: 'ModelNumber', header: 'Model'},
      {field: 'equipmentserialnumber', header: 'Serial Number'},
      {field: 'equipmentdescription', header: 'Equipment Description'},
      {field: 'dateCalibrated', header: 'Date Calibrated'}
    ]
                        
    this.ShowAlertpopup=false;
    this.ShowPrintPopup=false;
    this.SearchTicketColumns=[
      
      { field: 'ticketId', header: 'TicketID',display: 'none' },
      { field: 'ticketNumber', header: 'Ticket #' ,display: 'table-cell'},
      { field: 'facilityName', header: 'Location',display: 'table-cell' },
      { field: 'modelDescription', header: 'Model',display: 'table-cell' },
      { field: 'workTypeDescription', header: 'Work Type',display: 'table-cell' },
      { field: 'sqaDescription', header: 'SQA Code',display: 'table-cell' },
      { field: 'sqaSubDescription', header: 'SQA Sub Code',display: 'table-cell' },
      { field: 'equipmentSerialNumber', header: 'Serial #' ,display: 'table-cell'},
      { field: 'dateCreated', header: 'Date Created',display: 'table-cell' },
      { field: 'modifiedByFullname', header: 'Last Modified By',display: 'table-cell' }
      
    ]

    //this.userFacilityIdList=this.facilityService.getCurrentUserFacilityMasterIdList()
    this.userFacilityIdList=this.facilityService.getCurrentUserFacilityMasterIdList()

  }
 
  public dashTickets(dashTicketsParam:any) {
    this.ShowLodingGrid = true;
    this.SearchTicketResult = [];
    var DASHTICKETS = this.dashTicketsParam;
    if (DASHTICKETS != null) {
      this._TicketsService.dashTickets(JSON.stringify( {DASHTICKETS}))
      .subscribe((dashTicketsResponse: any) => {
        if(dashTicketsResponse.length> 0)
        {
          this.SearchTicketResult = dashTicketsResponse;
          this.totalRecordsTicektSearch= dashTicketsResponse.length;
          this.ShowLodingGrid = false;
        }
        else
        {
          this.totalRecordsTicektSearch= 0 ;
          this.ShowLodingGrid = false;
        }
      
        }, (respose: Response) => {
          this.ShowLodingGrid = false;
        }
      );
    }
  }
  searchTickets()
  {
    this.userFacilityIdList=this.facilityService.getCurrentUserFacilityMasterIdList()
    var errorsSearchTickets = this.validateSearchTickets();
    if(errorsSearchTickets!='')
    {
      this._messageService.showAlertMessage(errorsSearchTickets);
      return false;
    }
    else
    {
      this.dashTicketsParam.facilityMasterIdList =  this.userFacilityIdList;
     //this.dashTicketsParam.facilityMasterIdList ="3627,1682,5301";
     this.dashTicketsParam.ticketStatusId =this.tiketSrch.ticketStatusId
     this.dashTicketsParam.SearchTerm = this.tiketSrch.searchTerm;
     this.dashTicketsParam.ticketSearchStartDate= this.datePiepe.transform(this.tiketSrch.ticketSearchStartDate, "MM/dd/yyyy");//new Date(this.tiketSrch.ticketSearchStartDate).toLocaleDateString();
     this.dashTicketsParam.ticketSearchEndDate=this.datePiepe.transform(this.tiketSrch.ticketSearchEndDate, "MM/dd/yyyy"); //new Date(this.tiketSrch.ticketSearchEndDate).toLocaleDateString();
     this.dashTicketsParam.orderBy ="ticketId desc";
     this.dashTicketsParam.bartRoleCode =this.userDetail.bartRoleCode; //"Admin";
     this.dashTicketsParam.returnAllRecords = 1;
     this.dashTicketsParam.returnTotalCount =0 //50;
     this.dashTicketsParam.maxRecords= 50;
     this.dashTicketsParam.nextTicketId=null;
     this.dashTicketsParam.userId = this.userDetail.userId;//36679; 
     //Start:Added By Harikesh on 08-Sep-2020 for Defect#12154
     if(this.userFacilityIdList!=null && this.userFacilityIdList.length>0 && this.userFacilityIdList!="0")
     {
      this.dashTickets(this.dashTicketsParam);
     }
     else
     {
        this.ShowLodingGrid = true;
        this.facilityService.getUserLocationFacilities(this.userDetail.userName,(facilities:UserLocationFacility[])=>
        {
          let objUserFacilities:UserLocationFacility[]=facilities
          this.dashTicketsParam.facilityMasterIdList=objUserFacilities.map(x => x.FacilityMasterID).join(", ");
          this.dashTickets(this.dashTicketsParam);
        });
     }
    //End:Added By Harikesh on 08-Sep-2020 for Defect#12154
    
    }

  }

  validateSearchTickets()
  { 
    let tiketSrchErrors:string = "";
    if(this.tiketSrch.ticketSearchStartDate == undefined||this.tiketSrch.ticketSearchStartDate == null) {
      
      tiketSrchErrors="Date begin is not a valid date.";
    }
    if(this.tiketSrch.ticketSearchEndDate == undefined||this.tiketSrch.ticketSearchEndDate == null) {
      if(tiketSrchErrors!='')
      {
      tiketSrchErrors+="<br/>" +"Date end is not a valid date.";
      }
      else{
        tiketSrchErrors= "Date end is not a valid date.";
      }
    }
    

    return  tiketSrchErrors ;

  }


  OpenTickets()
  {
    
   if(this.selectedTicket.length> 0)
   {
    
     for (let c of this.selectedTicket) {
      
      // window.open("tickets?ticketId="+c.ticketId ,"_blank");
      window.open("tickets/"+c.ticketId ,"_blank");
      }

   }
   
  }

  printTickets()
  {
    if(this.selectedTicket.length> 0)
   {
    this.ShowLodingGrid = true;
     var TICKETIDLIST = this.selectedTicket.map(x=>x.ticketId).join(",");
     this.getTicketData(TICKETIDLIST,()=>
     {
     
      this.triggerPrintButtonClick(); 
     });
     this.ShowPrintPopup=false;
   }
   
  }
  TicketsData: SearchTicketDetails[]=null;
  //public partUse:any[]=[]
  //public testEquipmentUsed:any[]=[]

  public objTicktes:tktVM[]=[]
  public getTicketData(ticketId,callBack) {
    let tickObj: TicketDetails;
    
    let getTicketDetailParam =
    {
      "GETTICKET": {
        UserID: this.userDetail.userId,
        BartRoleID: this.userDetail.bartRoleId,
        TicketID: ticketId
      }

    }
    this._TicketsService.getTicket(JSON.stringify(getTicketDetailParam)).subscribe(data => {
      if (data != null && data.length > 0) {
       // tickObj = data.find(x => x.ticketId == ticketId);
        //this.populateTicketDetails(tickObj)
        this.TicketsData = data;
        let ticketCount:number=1;
        for (let objeTikcet of this.TicketsData) {
           let obj:tktVM=new tktVM() ;
           obj.ticketid=objeTikcet.ticketId;
           obj.tikcetDetails=objeTikcet;
           this.objTicktes.push(obj);
         // objeTikcet.ticketParts.push()
            //************************************************************************ */

            this.loadTicketTestEquip(objeTikcet.ticketId);
            var i = 0;
            var partTotal = 0;
            let getTicketPartsParam =
            {
              "GETTICKETPARTS": {
                TicketID: objeTikcet.ticketId
              }
            }
            this._TicketsService.getTicketParts(JSON.stringify(getTicketPartsParam)).subscribe(data => 
              {
                
                if (data != null && data.length > 0) {
                
              //this.objTicktes.find(x=>x.ticketid==ticketId).PartUsed=data
              
              this.TicketsData.find(x=>x.ticketId==objeTikcet.ticketId).ticketParts=data
             
              //************************************************ */

              for (let objeTikcet of this.TicketsData)
               {
                 if(objeTikcet.ticketParts)
                 {
                  for( let partsRec of objeTikcet.ticketParts) 
                  {
                    partsRec.Total = (partsRec.Quantity * partsRec.UnitCost);

                  }
                 }

                
                objeTikcet.totalTime=Number(objeTikcet.HoursWork+objeTikcet.HoursTravel);


              }
              //Calculate total Time
             
              this.partTotalAmount =objeTikcet.ticketParts.filter(item => item.UnitCost === item.UnitCost)
              .reduce((sum, current) => sum + current.UnitCost, 0);
            
              //************************************************** */
              
                }
                if(ticketCount==this.TicketsData.length)
                { 
                  callBack();
                }
                ticketCount++;
            });
           
            //************************************************************************ */
            objeTikcet.totalTime=Number(objeTikcet.HoursWork+objeTikcet.HoursTravel);
         
         }

          

      }
    },
      (error) => {
        tickObj = null;
        console.log(error);
      });
  }

  public partsUsedDuringRepair:any[]=[]
  public loadTicketParts(ticketId) {
    var i = 0;
    var partTotal = 0;
    let getTicketPartsParam =
    {
      "GETTICKETPARTS": {
        TicketID: ticketId
      }
    }
    this._TicketsService .getTicketParts(JSON.stringify(getTicketPartsParam)).subscribe(data => {
      if (data != null && data.length > 0) {

      
        return this.partsUsedDuringRepair = data;

      }
      else {
        return []
        //this.formFields.ispartsUsedRadio = "no";
      }
     
    },
      (error) => {
        console.log(error);
      }
    )
  }
  public testEquipmentUsedDuringRepair:any[]=[]
  public loadTicketTestEquip(ticketId) {

    var i = 0;
    var testEquipTotal = 0;
    let getTestEquipmentParam =
    {
      "GETTICKETTESTEQUIP": {
        TicketID: ticketId
      }
    }
    this._TicketsService.getTicketTestEquip(JSON.stringify(getTestEquipmentParam)).subscribe(data => {
      if (data != null && data.length > 0) {
        this.TicketsData.find(x=>x.ticketId==ticketId).ticketEquipment =data 
      } 
    },
      (error) => {
        console.log(error);
      }
    )
  }
  reset() {
    this.first = 0;
  }
  

 triggerPrintButtonClick() {
 
setTimeout(() => {
  this.ShowLodingGrid = false;
  let element =  <HTMLButtonElement>document.getElementById("printBatchTicket");
  element.click();
}, 2000);

}
public styleName:string="";
public useExistingCss:boolean=true;
public applyPrintCSSForProductionBuild()
  {
    
    this.useExistingCss=true;
    if (ConfService.conf.environment.production) {
      this.useExistingCss = false;
      const elements = document.getElementsByTagName('link');
      for (let index = 0; index < elements.length; index++) {
        console.log(elements[index].href);
        //if (elements[index].href.startsWith(document.baseURI)) {
          this.styleName += elements[index].href + ',';
        //}
      }
      this.styleName = this.styleName.slice(0, -1);
    }
    console.log("Production Build: "+ConfService.conf.environment.production);
    console.log("styleName: "+this.styleName);
    console.log("useExistingCss: "+this.useExistingCss);
    
  }

  public searchradioButtonClicked()
  {
    this.SearchTicketResult=[]; 
    this.selectedTicket=null;

  }
  public hasCreateTicketPermission:boolean
  public checkCreateTicketPermission()
  {
    this.hasCreateTicketPermission = true;
    if("ANALYST,HHD".split(",").indexOf(this.userDetail.bartRoleCode)>-1)
    {
      this.hasCreateTicketPermission= false;      
    }
  }

}

export interface ticketSearch {
  ticketStatusId?:number;
	searchTerm?:string
	 ticketSearchStartDate?:Date;
  ticketSearchEndDate?:Date;
};

export interface SearchTicketDetails {
  ticketId: number;
  workTypeId: number;
  isScheduledFlag: number;
  ticketStatusId: number;
  facilityMasterId: number;
  equipmentId: number;
  ticketNumber: string;
  dateCreated: Date;
  createdBy: number;
  serviceRequested: string;
  SQACodeId: number;
  SQASubCodeId?: any;
  pmSequenceId?: any;
  isPMByHoursFlag?: any;
  DateServiceBegan: Date;
  DateServiceRequested: Date;
  DateServiceRequested1: Date;
  DateServicePerformed?: any;
  DateClosed?: any;
  ClosedBy?: any;
  ClockHours?: any;
  PayrollCodeID?: any;
  HoursWork?: any;
  HoursTravel?: any;
  Findings?: any;
  WorkPerformed?: any;
  ElectricalLeakage?: any;
  GroundWireResistance?: any;
  isServiceMatchFindingsFlag?: any;
  isChecklistCompletedFlag?: any;
  isEquipmentReleasedForTreatmentFlag?: any;
  isBatchFlag: number;
  isCloneFlag: number;
  DateModified: Date;
  ModifiedBy: number;
  BatchId?: any;
  additionalComments?: any;
  facilityName: string;
  divisionMasterId: number;
  divisionName: string;
  regionMasterId: number;
  regionName: string;
  facilityNumber: string;
  workTypeDescription: string;
  isCanBatchFlag: number;
  modelId: number;
  modelDescription: string;
  equipmentTypeId: number;
  hasClock: number;
  equipmentSerialNumber: string;
  lastClockHours?: any;
  equipmentTypeDescription: string;
  equipmentTypeDescription1: string;
  manufacturerName: string;
  sqaCode: string;
  fullname: string;
  fullnamefirstlast: string;
  waterVolume?: any;
  waterDurationA?: any;
  waterDurationB?: any;
  waterDurationC?: any;
  waterDUrationD?: any;
  waterDurationE?: any;
  waterFrequency?: any;
  waterVolumeMonthly?: any;
  waterTemperatureVolume?: any;
  waterTemperature?: any;
  networkSurveyA?: any;
  networkSurveyB?: any;
  networkSurveyC?: any;
  networkSurveyD?: any;
  networkSurveyE?: any;
  covidAttestationA?: any;
  covidAttestationB?: any;
  covidAttestationC?: any;
  Actuator?: any;
  GeneralSoftware?: any;
  Functional?: any;
  ticketParts?:buildingUsedRepair[];
  ticketEquipment?:EquipmentUsedDuringRepair[];
  totalTime?:number;
}

export interface buildingUsedRepair {
  Quantity: number;
  partId?: number;
  partNumber?: string;
  manufacturerName?: string;
  partDescription?: string;
  originalUnitCost?: number;
  UnitCost?: number;
  dateOfInstall?: string;
  isPartUnderWarranty: number ;
  rgaNumber?: '';
  showRgaOptions?: number ;
  ticketPartSourceId?: number;
  isReplacingWarrantyPartFlag?: boolean ;
  isRGAQualifiedFlag?: boolean ;
  zeroCost?: boolean ;
  Total:number;
}

export interface EquipmentUsedDuringRepair
{
    equipmentId?:number;
    subType?:string;
    manufacturer?:string;	
    modelNumber?:string	;
    serialNumber?:string	
    equipmentDescription?:string;
    dateCalibrated?:string;
    quantity?:number;
}
export class tktVM
{
  ticketid:number
  tikcetDetails:TicketDetails
  PartUsed:buildingUsedRepair[]
}
